module.exports = __webpack_public_path__ + "static/media/brandTick.cbcf91ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brandTick.svg
// module id = 639
// module chunks = 0